import cloneDeep from 'lodash/fp/cloneDeep';
import { RECEIVE_SITE_OPTIONS } from 'config/types/action';

/**
 * State slice reducer for menu related actions.
 * @param {object}   state   menu state slice
 * @param {string}   type
 * @param {*}        payload
 * @returns {object}
 */
export default function menuReducer(state = {}, { type, payload }) {
  switch (type) {
    case RECEIVE_SITE_OPTIONS:
      return cloneDeep(payload.menu);
    default:
  }

  return state;
}
